import Button from "@mui/material/Button";
import {  assertObject } from "core/validation";
import log from "loglevel";
import React, { Fragment, useCallback, useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { useSelectIconStyles } from "./uploadStyles";

export const IMAGE_MIME_TYPES = ["image/jpeg", "image/png", "image/jpg", "image/ico"];

export const UPLOAD_TYPES = {
    SIGNATURE: {
        name: "SIGNATURE",
        mimeTypes: IMAGE_MIME_TYPES,
        isMultiple: false,
        title: "Upload Logo",
        uploadBackground: false,
        maxSize: Infinity,
    },
};
function UploadFromDisk({
    onFileSelected,
    uploadType,
    isAssetInvalid,
    children,
    trigger,
    componentView,
    buttonLabel,
    buttonIcon,
    assetIds,
}) {
    
    const classes = useSelectIconStyles();

    const onDrop = useCallback((acceptedFiles) => {
        onFileSelected(acceptedFiles);
    }, [onFileSelected]);
    const { acceptedFiles, getRootProps, getInputProps, open, isDragActive, isDragAccept, isDragReject } = useDropzone({
        noClick: true,
        accept: uploadType.mimeTypes.join(", "),
        multiple: uploadType.isMultiple,
        onDrop,
    });
    const dragClassname = useMemo(() => {
        return isDragReject
            ? classes.dragContainerRejected
            : isDragAccept
                ? classes.dragContainerAccept
                : isDragActive
                    ? classes.dragContainerActive
                    : null;
    }, [isDragReject, classes.dragContainerRejected, classes.dragContainerAccept, classes.dragContainerActive, isDragAccept, isDragActive]);
    const view = React.cloneElement(
        componentView,
        {
            isAssetInvalid,
            assetIds,
            acceptedFiles,
            dragClassname,
            uploadType,
            isDragActive,
            isDragReject,
            isDragAccept,
        },
        children
    );
    const _trigger = trigger ? (
        React.cloneElement(trigger, {
            onClick: open,
        })
    ) : (
        <Button variant="outlined" color="primary" onClick={open} startIcon={buttonIcon}>
            {buttonLabel ? buttonLabel : "Choose files"}
        </Button>
    );
    return (
        <Fragment>
            <div className={assertObject(trigger) ? "" : classes.tabContainer} {...getRootProps()}>
                <input {...getInputProps((event) => log.debug("Attaching files", event))} />
                {_trigger}
                {children}
                {view}
            </div>
        </Fragment>
    );
}

export default UploadFromDisk;
